import React from 'react';
import HomepageHighlights from './Sections/HomepageHighlights';
import GallerySection from './Sections/GallerySection';
import NewsEventsSection from './Sections/NewsEventsSection';
import NoticeAnnouncementSection from './Sections/NoticeAnnouncementSection';
import CampusToCareerSection from './Sections/CampusToCareerSection';
import HeroSectionsManager from './Sections/HeroSectionsManager';
import FooterSectionsManager from './Sections/FooterSectionsManager';
import PopupSectionsManager from './Sections/PopupSectionsManager';
import CalendarSectionsManager from './Sections/CalendarSectionsManager';
import Wrapper from '../../Main/Universal/Wrapper';

export default function Home() {
    return (
        <Wrapper page_name="homepage">
            <ul class="nav nav-tabs home-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="hero-sections-tab" data-bs-toggle="tab" data-bs-target="#hero-sections" type="button" role="tab" aria-controls="hero-sections" aria-selected="true">Hero Sections</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="home-highlights-tab" data-bs-toggle="tab" data-bs-target="#home-highlights" type="button" role="tab" aria-controls="home-highlights" aria-selected="false">Home Highlights</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="about-section-tab" data-bs-toggle="tab" data-bs-target="#about-section" type="button" role="tab" aria-controls="about-section" aria-selected="false">About Section</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="gallery-tab" data-bs-toggle="tab" data-bs-target="#gallery" type="button" role="tab" aria-controls="gallery" aria-selected="false">Gallery Section</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="news-events-tab" data-bs-toggle="tab" data-bs-target="#news-events" type="button" role="tab" aria-controls="news-events" aria-selected="false">News & Events Section</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="notice-announcement-tab" data-bs-toggle="tab" data-bs-target="#notice-announcement" type="button" role="tab" aria-controls="notice-announcement" aria-selected="false">Notice & Announcement Section</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="campus-to-career-tab" data-bs-toggle="tab" data-bs-target="#campus-to-career" type="button" role="tab" aria-controls="campus-to-career" aria-selected="false">Campus to Career Section</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="footer-sections-tab" data-bs-toggle="tab" data-bs-target="#footer-sections" type="button" role="tab" aria-controls="footer-sections" aria-selected="false">Footer Sections</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="popup-sections-tab" data-bs-toggle="tab" data-bs-target="#popup-sections" type="button" role="tab" aria-controls="popup-sections" aria-selected="false">Popup Sections</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="calendar-sections-tab" data-bs-toggle="tab" data-bs-target="#calendar-sections" type="button" role="tab" aria-controls="calendar-sections" aria-selected="false">Calendar Sections</button>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="hero-sections" role="tabpanel" aria-labelledby="hero-sections-tab">
                    <hr />
                    <HeroSectionsManager />
                </div>
                <div class="tab-pane fade" id="home-highlights" role="tabpanel" aria-labelledby="home-highlights-tab">
                    <hr />
                    <HomepageHighlights />
                </div>
                
                <div class="tab-pane fade" id="gallery" role="tabpanel" aria-labelledby="gallery-tab">
                    <hr />
                    <GallerySection />
                </div>
                <div class="tab-pane fade" id="news-events" role="tabpanel" aria-labelledby="news-events-tab">
                    <hr />
                    <NewsEventsSection />
                </div>
                <div class="tab-pane fade" id="notice-announcement" role="tabpanel" aria-labelledby="notice-announcement-tab">
                    <hr />
                    <NoticeAnnouncementSection />
                </div>
                <div class="tab-pane fade" id="campus-to-career" role="tabpanel" aria-labelledby="campus-to-career-tab">
                    <hr />
                    <CampusToCareerSection />
                </div>
                <div class="tab-pane fade" id="footer-sections" role="tabpanel" aria-labelledby="footer-sections-tab">
                    <hr />
                    <FooterSectionsManager />
                </div>
                <div class="tab-pane fade" id="popup-sections" role="tabpanel" aria-labelledby="popup-sections-tab">
                    <hr />
                    <PopupSectionsManager />
                </div>
                <div class="tab-pane fade" id="calendar-sections" role="tabpanel" aria-labelledby="calendar-sections-tab">
                    <hr />
                    <CalendarSectionsManager />
                </div>
            </div>
        </Wrapper>
    )
}
